const state = {
  uid: "",
  userType: 1
};

const mutations = {
  SET_USER: (state, data) => {
    state.uid = data.uid;
    state.userType = data.userType;
  }
};

const actions = {
  setUserDataDoc({ commit }, data) {
    commit("SET_USER", data);
  }
};

export default {
  state,
  mutations,
  actions
};
